import styled from 'styled-components';
import query from 'syf-component-library/const/mediaQueries';
import { Inset } from 'syf-component-library/ui/spacing';
import colors from '../../../../../const/colors';
export const NoteContainer = styled(Inset) `
  margin: auto;
  background-color: ${colors.lighterGray};
  max-width: 672px;
  width: 90%;
  font-size: 14px;

  @media ${query.lessThanSmall} {
    border-radius: 5px;
  }
`;
